import './social-network-banner.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';
import { timer } from 'rxjs';

import { SocialNetworkModel } from '../../model/social-network-model';
import { ISocialNetworkFrameService } from '../../services/social-network-frame.service';
import templateUrl from './social-network-banner.template.html';

const MODULE_NAME = 'socialNetworkBanner';

class SocialNetworkBannerCtrl implements IComponentController {
  public name = MODULE_NAME;
  showBanner: boolean = true;
  currentTime: number = Date.now();

  constructor(public readonly $i18next: i18n, private readonly socialNetworkFrameService: ISocialNetworkFrameService) {}

  $onInit() {
    timer(1000)
      .pipe(ng1Destroy(this))
      .subscribe(() => (this.currentTime = Date.now()));
  }

  moveBanner(): void {
    this.showBanner = !this.showBanner;
  }

  public isSelected(socialNetwork: SocialNetworkModel): boolean {
    return this.socialNetworkFrameService.activeSocialNetwork === socialNetwork;
  }

  selectSocialNetwork(selectedSocialNetwork: SocialNetworkModel): void {
    this.socialNetworkFrameService.selectSocialNetwork(selectedSocialNetwork);
  }

  postTreatmentDurationExceeded(socialNetwork: SocialNetworkModel) {
    let isPostTreatmentExceededMode = socialNetwork.postTreatmentDurationExceeded(this.currentTime);
    if (isPostTreatmentExceededMode && !socialNetwork.inPostTreatmentExceededMode) {
      socialNetwork.inPostTreatmentExceededMode = true;
      this.socialNetworkFrameService.updateSocialNetworkHavePostTreatmentDurationExceeded();
    }
    return isPostTreatmentExceededMode;
  }
}

export class SocialNetworkBanner implements IComponentOptions {
  templateUrl = templateUrl;
  controller = ['$interval', '$i18next', 'socialNetworkFrameService', SocialNetworkBannerCtrl];
}

export default MODULE_NAME;
